export default __webpack_public_path__ + "static/media/ukrainego-screenshot-02.0ca68631.png";